import React from 'react'

import { myWalletCurrencies } from '../../../constants'

const SelectCurrency = ({
  value,
  onChange,
  size = 'w-[48px] h-[48px]',
  className = '',
  itemClassName = '',
}) => {
  const myWalletCurrenciesContent = myWalletCurrencies.map((walletCurrency) => {
    return (
      <button
        key={walletCurrency.icon}
        className={`${size} opacity-70 hover:opacity-100 ${value === walletCurrency.value ? '!opacity-100' : ''} ${itemClassName}`}
        onClick={() => onChange(walletCurrency.value)}
      >
        <img
          className={`inline-block w-full h-full !border-2 border-transparent rounded-circle ${value === walletCurrency.value ? '!border-primary-300' : ''}`}
          src={walletCurrency.icon}
          alt={walletCurrency.value}
          draggable={false}
        />
      </button>
    )
  })

  return (
    <div className={`w-full flex items-center justify-center gap-x-[4px] ${className}`}>
      {myWalletCurrenciesContent}
    </div>
  )
}

export default SelectCurrency
